const _ = require('lodash');

function ContextFactory(RRConfig, RRInstance, CurrentUserService, RREventSend, $window) {
	this._config = RRConfig;
	this._user = CurrentUserService.get();
	this._common = RRInstance.COMMON;
	this._rrEventSend = RREventSend;
	this._$window = $window;
}

ContextFactory.prototype.execute = function (eventCallback) {
	const user = this._user, config = this._config, $window = this._$window;
	if (!this._common) {
		return;
	}
	const common = $window.R3_COMMON = new this._common();
	common.setApiKey(config.apiKey);
	common.setBaseUrl($window.location.protocol + config.url);
	common.setClickthruServer([$window.location.protocol, '//', $window.location.host].join(''));
	if (_.isEmpty(config.sessionId)) {
		throw new Error('SessionId not being passed in app-init.js');
	}
	common.setSessionId(config.sessionId);
	if (!_.isEmpty('' + user.id)) {
		common.setUserId(user.id);
	}
	eventCallback(common);
	this._rrEventSend.flush();
	$window.R3_COMMON = null;
};

module.exports = ContextFactory;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/richer-relevance/rr-context-factory.js
 **/